import React from 'react';
import { useState } from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Card from 'react-bootstrap/Card';
import { SignIn, UserCircle } from 'phosphor-react';
import { Link } from 'react-router-dom';
import "../../src/helper/Header.css"
import mlj from "../helper/images/mlj.png";
import moe_logo from "../helper/images/moe_logo.png";
import anu_logo from "../helper/images/anuvadini_logo.png"

function LoginPage() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState();
  const [password, setPassword] = useState();

  const loginHandler = (e) => {
    e.preventDefault()
    let formData = { "mobile": userName, 'password': password };
    axios
      .post(process.env.REACT_APP_BASE_URL + "user-login", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.data.status === "success") {
          localStorage.setItem("legaltoken", response.data.token);
          localStorage.setItem("legalIsLogin", true);
          localStorage.setItem("legalLanguage", response.data.data.user.defaultLanguage);
          if (response.data.data.user.role === 'user') {
            navigate("/lawdictionary/user-request-list");
          } else {
            navigate("/lawdictionary/request-list");
          }
        }
      })
      .catch(function (response) {
        alert("Invalid Credentials!");
      });
  }


  return (
    <>
      <div className="topDivLogin searchList">
        <header className="headerLst">
          <div className="container mainSrchDiv">
            <div className="mainSrchDivIn">
              <div className="row align-items-center">
                <div className="logoarea col-12 col-sm-12 col-md-9 col-lg-9">
                  <div className="d-flex justify-content-start flex-wrap align-items-center">
                    <div className="listLogo">
                      <a href="https://anuvadini.aicte-india.org/">
                        <img src={anu_logo} width="210px" />
                      </a>
                      <a>
                        <img src={mlj} alt="" width="220px" style={{ marginLeft: 10 }} />
                      </a>
                      <a href="">
                        <img src={moe_logo} alt="" style={{ marginLeft: 10, }} width="120" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                  <div className="d-flex justify-content-end align-items-center phonecenter">
                    <div className="d-flex justify-content-end flex-wrap buttonmargin">
                      <button className="feedbackSpn h-auto w-auto mr-3" style={{ height: 36, }} onClick={() => { navigate('/lawdictionary') }}>
                        Home
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>

      <div className='container loginFooter'>
        <Card className='loginCard'>
          <Card.Body>
            <form onSubmit={loginHandler}>
              <div className='text-center'>
                <UserCircle size={80} color="#113168" />
                <h3>Sign In</h3>
              </div>
              <div className="mb-3">
                <label>Mobile Number</label>
                <input type="number" className="form-control" value={userName} onChange={(e) => setUserName(e.target.value)} />
              </div>

              <div className="mb-3">
                <label>Password</label>
                <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} />
              </div>

              <div className="d-grid">
                <button type="submit" className="btnsuccess w-auto"><SignIn size={20} />Submit</button>
              </div>
            </form>

            <div className="text-center">
              <Link to="/lawdictionary/register">Create New Account </Link>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  )
}

export default LoginPage;

